// extracted by mini-css-extract-plugin
export default {"divMain":"WhatWeBuy_divMain__xiiUX"};